function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 130,
    viewBox: "0 -960 960 960",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(83,170,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    d: "M478-226q-49-32-104-49t-114-17q-28 0-55 3.5T152-276q-22 8-41-6t-19-38v-356q0-16 9-28.5t23-17.5q32-13 66.5-19.5T260-748q59 0 114 19t106 48.64V-253q50-32.5 106.5-46.75T700-314q32 0 59 3.5t57 14.5q11 3 20.5 0t9.5-16v-408q1.3-.31 2.15.34.85.66 1.85 1.66 9 5 13.5 14t4.5 20v362q0 24-20.5 37.5T802-278q-25-8-50.5-11t-51.5-3q-60 0-117 15.5T478-226Zm76-124v-320l218-218v344L554-350Zm-96 86v-404q-46-27-96.5-42.5T260-726q-40 0-72 7.5t-55 16.03q-8 3-13.5 8.5t-5.5 13.5V-311q0 14 9.5 16.5T144-296q21-8 49.5-13t67-5q61.5 0 114 15.5T458-264Zm0 0v-404 404Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual3);
export default __webpack_public_path__ + "static/media/manual3.990dd7adbd5a21d8a13681fefe551e22.svg";
export { ForwardRef as ReactComponent };